window.addProductToCart = async function ({
  variantId,
  sku,
  quantity,
  dispatchDate,
  message,
  recipientEmail,
  recipientName,
  giftCardMessage,
  pleaseNote,
  sendOn,
  voucher,
  hash,
  redemptionFee,
  parentProductId,
  additionalProperties,
  additionalItemFields
}) {
  await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: quantity,
          ...additionalItemFields,
          properties: {
            SKU: sku,
            ...(dispatchDate && {
              'Dispatch Date': dispatchDate
            }),
            ...(message && {
              message
            }),
            ...(recipientEmail && {
              'Recipient email': recipientEmail,
              'Recipient name': recipientName,
              Message: giftCardMessage,
              'Please note': pleaseNote,
              'Send on': sendOn,
              __shopify_send_gift_card_to_recipient: true
            }),
            ...(voucher && {
              _voucher: voucher
            }),
            ...(typeof redemptionFee === 'number' && {
              _redemption_fee: redemptionFee
            }),
            ...(hash && {
              _hash: hash
            }),
            ...(parentProductId && {
              _parent_product_id: parentProductId
            }),
            ...additionalProperties
          }
        }
      ]
    })
  })
}

window.addProductToCartAndUpdateCartDrawer = async function ({
  variantId,
  sku,
  dispatchDate,
  parentProductId
}) {
  //if adding a special price product, ensure the parent product is in the cart before adding it
  if (parentProductId) {
    const cartData = await fetch(`${window.Shopify.routes.root}cart.json`).then(
      (res) => res.json()
    )

    const parentProductInCart = cartData.items.find(
      (item) => item.product_id === parentProductId
    )

    if (!parentProductInCart) {
      return
    }
  }

  await window.addProductToCart({
    variantId,
    sku,
    quantity: 1,
    dispatchDate,
    parentProductId
  })
  updateCartDrawer()
  updateHeaderCartCount()
}

window.getProductDispatchDates = async function (product_id) {
  const query = `
    {
      product(id: "gid://shopify/Product/${product_id}"){
        id
        title
        metafield(namespace: "custom", key: "dispatch_dates"){
          id
          reference {
            ... on Metaobject {
              id
              type
              fields {
                key
                value
              }
            }
          }
        }
      }
    }`

  const response = await fetch('/api/2025-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'b979e3a4d20b7d4a007170ff1b8a660a'
    },
    body: JSON.stringify({ query })
  })
  const responseJson = await response.json()

  const fields = responseJson?.data?.product?.metafield?.reference?.fields

  if (fields === undefined) return []

  const uk_dates = fields.find((field) => field.key === 'uk_dates')
  const eu_dates = fields.find((field) => field.key === 'eu_dates')
  const ukCountryCodes = ['GB', 'GG', 'IM', 'JE']
  const countryCode =
    Shopify?.customer?.default_address?.country_code ?? Shopify.country
  const marketSpecificDates = ukCountryCodes.includes(countryCode)
    ? uk_dates
    : eu_dates

  const sortedDates = JSON.parse(marketSpecificDates.value)
    .sort()
    .map((str) => {
      //ensures date is correct regardless of timezone
      const [year, month, day] = str.split('-').map(Number)
      return new Date(year, month - 1, day)
    })

  return sortedDates
}

window.toDateKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
